// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Input {
  width: 100%;
  margin: 0;
}

.Input .Input__container {
  display: flex;
  border-radius: 0 2px 0 2px;
  padding-top: 0.14rem;
  padding-bottom: 0.14rem;
}

.Input .Input__container input {
  padding-bottom: 0.71rem;
  padding-top: 1.86rem;
  color: var(--palette-text);
}

.Input .Input__container,
.Input .Input__container:hover,
.Input .Input__container.Input__container--focused {
  background-color: var(--palette-whipe);
}

.Input--transparent .Input__container,
.Input--transparent .Input__container:hover,
.Input--transparent .Input__container.Input__container--focused {
  background-color: rgba(0, 0, 0, 0);
}

.Input.Input--thribee-yellow .Input__container,
.Input.Input--thribee-yellow .Input__container.Input__container--focused,
.Input.Input--thribee-yellow .Input__container:not(.Input__container--disabled):hover {
  background-color: var(--palette-thribee-yellow-opacity6);
}

.Input .Input__container.Input__container--disabled {
  color: var(--unknown-grey-to-review-A5A5A5);
  background-color: var(--palette-gray-7-opacity12);
}

.Input .Input__container.Input__container--disabled .Input__prefix .SvgIcon {
  color: var(--unknown-grey-to-review-A5A5A5);
}

.Input .Input__container.Input__container--underline::before ,
.Input .Input__container.Input__container--underline:hover::before {
  border-bottom-color: var(--palette-disabled);
}

.Input.Input--thribee-yellow.Input--thribee-yellow .Input__container.Input__container--underline::before ,
.Input.Input--thribee-yellow.Input--thribee-yellow .Input__container.Input__container--underline:hover::before {
  border-bottom-color: var(--palette-thribee-yellow);
}

.Input__container.Input__container--underline.Input__container--disabled::before,
.Input__container.Input__container--underline.Input__container--disabled:hover::before {
  border-bottom-color: var(--palette-disabled);
  border-bottom-style: solid;
}

.Input .Input__container.Input__container--disabled input {
  color: var(--unknown-grey-to-review-A5A5A5);
}

.Input .Input__container.Input__container--disabled input:disabled {
  cursor: not-allowed;
}

.Input__container.Input__container--underline::after {
  border-bottom-color: var(--palette-trovit-blue);
}

.Input--thribee-yellow .Input__container.Input__container--underline::after {
  border-bottom-color: var(--palette-thribee-yellow);
}

.Input .Input__label,
.Input .Input__label.Input__label--focused {
  font-weight: normal;
  color: var(--palette-gray-8);
}

.Input .Input__label.Input__label--focused {
  color: var(--palette-trovit-blue);
}

.Input.Input--thribee-yellow .Input__label:not(.Input__label--disabled),
.Input.Input--thribee-yellow .Input__label:not(.Input__label--disabled).Input__label--focused {
  color: var(--palette-thribee-yellow);
  font-weight: bold;
}

.Input .Input__container div.Input__prefix {
  color: var(--palette-trovit-blue);
  margin-right: 0;
  margin-top: 1.18rem;
}

.Input.Input--thribee-yellow .Input__container .Input__prefix{
  color: var(--palette-thribee-yellow);
}

.Input .Input__container .Input__prefix + input {
  flex: 1;
}
`, "",{"version":3,"sources":["webpack://./js/components/library/mui4/input/Input.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,SAAS;AACX;;AAEA;EACE,aAAa;EACb,0BAA0B;EAC1B,oBAAoB;EACpB,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;EACvB,oBAAoB;EACpB,0BAA0B;AAC5B;;AAEA;;;EAGE,sCAAsC;AACxC;;AAEA;;;EAGE,kCAAkC;AACpC;;AAEA;;;EAGE,wDAAwD;AAC1D;;AAEA;EACE,2CAA2C;EAC3C,iDAAiD;AACnD;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;;EAEE,4CAA4C;AAC9C;;AAEA;;EAEE,kDAAkD;AACpD;;AAEA;;EAEE,4CAA4C;EAC5C,0BAA0B;AAC5B;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,+CAA+C;AACjD;;AAEA;EACE,kDAAkD;AACpD;;AAEA;;EAEE,mBAAmB;EACnB,4BAA4B;AAC9B;;AAEA;EACE,iCAAiC;AACnC;;AAEA;;EAEE,oCAAoC;EACpC,iBAAiB;AACnB;;AAEA;EACE,iCAAiC;EACjC,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,OAAO;AACT","sourcesContent":[".Input {\n  width: 100%;\n  margin: 0;\n}\n\n.Input .Input__container {\n  display: flex;\n  border-radius: 0 2px 0 2px;\n  padding-top: 0.14rem;\n  padding-bottom: 0.14rem;\n}\n\n.Input .Input__container input {\n  padding-bottom: 0.71rem;\n  padding-top: 1.86rem;\n  color: var(--palette-text);\n}\n\n.Input .Input__container,\n.Input .Input__container:hover,\n.Input .Input__container.Input__container--focused {\n  background-color: var(--palette-whipe);\n}\n\n.Input--transparent .Input__container,\n.Input--transparent .Input__container:hover,\n.Input--transparent .Input__container.Input__container--focused {\n  background-color: rgba(0, 0, 0, 0);\n}\n\n.Input.Input--thribee-yellow .Input__container,\n.Input.Input--thribee-yellow .Input__container.Input__container--focused,\n.Input.Input--thribee-yellow .Input__container:not(.Input__container--disabled):hover {\n  background-color: var(--palette-thribee-yellow-opacity6);\n}\n\n.Input .Input__container.Input__container--disabled {\n  color: var(--unknown-grey-to-review-A5A5A5);\n  background-color: var(--palette-gray-7-opacity12);\n}\n\n.Input .Input__container.Input__container--disabled .Input__prefix .SvgIcon {\n  color: var(--unknown-grey-to-review-A5A5A5);\n}\n\n.Input .Input__container.Input__container--underline::before ,\n.Input .Input__container.Input__container--underline:hover::before {\n  border-bottom-color: var(--palette-disabled);\n}\n\n.Input.Input--thribee-yellow.Input--thribee-yellow .Input__container.Input__container--underline::before ,\n.Input.Input--thribee-yellow.Input--thribee-yellow .Input__container.Input__container--underline:hover::before {\n  border-bottom-color: var(--palette-thribee-yellow);\n}\n\n.Input__container.Input__container--underline.Input__container--disabled::before,\n.Input__container.Input__container--underline.Input__container--disabled:hover::before {\n  border-bottom-color: var(--palette-disabled);\n  border-bottom-style: solid;\n}\n\n.Input .Input__container.Input__container--disabled input {\n  color: var(--unknown-grey-to-review-A5A5A5);\n}\n\n.Input .Input__container.Input__container--disabled input:disabled {\n  cursor: not-allowed;\n}\n\n.Input__container.Input__container--underline::after {\n  border-bottom-color: var(--palette-trovit-blue);\n}\n\n.Input--thribee-yellow .Input__container.Input__container--underline::after {\n  border-bottom-color: var(--palette-thribee-yellow);\n}\n\n.Input .Input__label,\n.Input .Input__label.Input__label--focused {\n  font-weight: normal;\n  color: var(--palette-gray-8);\n}\n\n.Input .Input__label.Input__label--focused {\n  color: var(--palette-trovit-blue);\n}\n\n.Input.Input--thribee-yellow .Input__label:not(.Input__label--disabled),\n.Input.Input--thribee-yellow .Input__label:not(.Input__label--disabled).Input__label--focused {\n  color: var(--palette-thribee-yellow);\n  font-weight: bold;\n}\n\n.Input .Input__container div.Input__prefix {\n  color: var(--palette-trovit-blue);\n  margin-right: 0;\n  margin-top: 1.18rem;\n}\n\n.Input.Input--thribee-yellow .Input__container .Input__prefix{\n  color: var(--palette-thribee-yellow);\n}\n\n.Input .Input__container .Input__prefix + input {\n  flex: 1;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
